import React from 'react';

import StartRecordingSteps from '../StartRecordingSteps/StartRecordingSteps';

const StartRecording = ({
	givenName,
	handleStartRecording,
	handleNotHome,
	isSurveyLoading,
}) => {
	const renderHeader = () => {
		const introText = (givenName) ? `${givenName}, an` : `An`; // prettier-ignore
		return <h3>{introText} accurate quote is a few quick videos away!</h3>;
	};

	const renderSubHeader = () => (
		<p className='sub-head'>
			Take a few short videos of the rooms in your house, and we will provide an
			accurate quote with no hidden fees.
		</p>
	);

	const renderStepsImage = () => (
		<div className='image'>
			<img
				src='https://media.yembo.ai/mariner/lander/demo.gif'
				alt='record-video'
			/>
		</div>
	);

	const renderStepsDesktop = () => (
		<div className='step-wrap-desktop'>
			<StartRecordingSteps />
		</div>
	);

	const renderInviteButton = () => (
		<div className='start-recording-button-wrap'>
			{/* button className used for Analytics - beware of changing */}
			<button onClick={handleStartRecording} className='start-recording-button'>
				{(isSurveyLoading) ? 'Loading...' : 'Start Recording' /* prettier-ignore */}
			</button>
		</div>
	);

	const renderReminderButton = () => (
		<div className='not-home-button-wrap'>
			{/* button className used for Analytics - beware of changing */}
			<button
				className='not-home-button'
				onClick={handleNotHome}
			>
				Not Home?
			</button>
		</div>
	);

	const renderStepsMobile = () => (
		<div className='step-wrap-mobile'>
			<StartRecordingSteps />
		</div>
	);

	return (
		<div className='start-recording-wrap'>
			{renderHeader()}
			{renderSubHeader()}
			<div className='image-step-wrap'>
				<div className='image-wrap'>
					{renderStepsImage()}
					{/* Steps desktop - Steps need to show to the right of the record-video gif on desktop */}
					{renderStepsDesktop()}
				</div>
				{renderInviteButton()}
				{renderReminderButton()}
				{/* Steps mobile - Steps need to show under the action buttons on mobile */}
				{renderStepsMobile()}
			</div>
		</div>
	);
};

export default StartRecording;
